<template>

    <div class="user_wbox">


        <div class="inter">
            <div class="div1 t-flex">
                <div class="fl">

                    <div class="user_menu2">
                        <div class="user_menu_div1">
                            <div class="wp1 active">
                                <div class="ic">
                                    <img src="@/assets/image/order_ic.png" />
                                </div>
                                <span>我的商品</span>
                            </div>
                            <div class="user_menu_list user_menu_list2">
                                <div class="item" :class="{ active: status == -1 }" @click="open(-1)">全部</div>
                                <div class="item" :class="{ active: status == 1 }" @click="open(1)">交易中</div>
                                <div class="item" :class="{ active: status == 2 }" @click="open(2)">已出售</div>
                                <!-- <div class="item" :class="{ active: status == 3 }" @click="open(3)">已取消</div> -->
                                <div class="item" :class="{ active: status == 4 }" @click="open(4)">审核失败</div>
                            </div>
                        </div>

                    </div>
                </div>
                <div class="fr fr2">
                    <el-empty description="暂无数据" v-if="list.length == 0"></el-empty>


                    <div class="order_mobile_list" v-if="isMobile">
                        <div class="item" v-for="(item, index) in list">
                            <div class="text_1">
                                <div class="sp1">编号 {{ item.id }}</div>
                                <div class="sp2" v-if="item.is_sell != 2 && item.status == 'pulloff'">已下架</div>
                                <div class="sp2" v-if="item.is_sell != 2 && item.status == 'hidden'">待审核</div>
                                <div class="sp2" v-if="item.is_sell == 2">已出售</div>
                            </div>
                            <div class="text_2">
                                <div class="image">
                                    <img src="@/assets/image/tu_biao.png" />
                                </div>
                                <div class="text">
                                    <div class="p1">{{ item.title }}</div>
                                    <div class="p2">
                                        <div class="item_text">
                                            <span class="sp1">创建时间:</span>
                                            <span class="sp2">{{ item.createtime }}</span>
                                        </div>
                                        <div class="item_text">
                                            <span class="sp1">备注:</span>
                                            <span class="sp2">{{ item.beizhu }}</span>
                                        </div>
                                    </div>
                                    <div class="p2">
                                        <div class="item_text">
                                            <span class="sp1">售价:</span>
                                            <span class="sp2">{{ item.price }}元</span>
                                        </div>
                                        <div class="item_text">
                                            <span class="sp1">区服:</span>
                                            <span class="sp2">({{ item.qufu_text }})</span>
                                        </div>
                                    </div>
                                </div>

                            </div>

                            <div class="text_3">
                                <div class="con goods-actions" v-if="item.is_sell == 0">
                                    <span class="sp1" @click="xiajia(index, item)"
                                        v-if="item.status == 'normal'">下架</span>
                                    <span class="sp1" @click="shangjia(index, item)"
                                        v-if="item.status == 'pulloff'">上架</span>

                                    <router-link class="sp2" target="_blank"
                                        :to="{ path: '/sell', query: { id: item.id } }">
                                        编辑
                                    </router-link>
                                    <span class="sp3" v-if="item.kefu_id" @click="showKefu(item)">查看客服</span>
                                </div>
                            </div>
                        </div>
                    </div>


                    <div class="my_goods_list" :key="list_num" v-if="!isMobile">
                        <div class="item" v-for="(item, index) in list">
                            <div class="con1">
                                <div class="text_1">
                                    <div class="sp1" v-if="item.is_sell != 2 && item.status == 'pulloff'">已下架</div>
                                    <div class="sp1" v-if="item.is_sell != 2 && item.status == 'hidden'">待审核</div>
                                    <div class="sp1" v-if="item.is_sell == 2">已出售</div>
                                    <div class="sp2">商品编号:{{ item.id }}</div>
                                    <div class="sp3">复制</div>
                                </div>
                                <div class="text_2">
                                    商品操作
                                </div>

                            </div>
                            <div class="con2">
                                <div class="text_1">
                                    <div class="image">
                                        <img src="@/assets/image/tu_biao.png" />
                                    </div>
                                    <div class="text">
                                        <div class="p1">{{ item.title }}</div>
                                        <div class="p2">
                                            <div class="item_text">
                                                <span class="sp1">创建时间:</span>
                                                <span class="sp2">{{ item.createtime }}</span>
                                            </div>
                                            <div class="item_text">
                                                <span class="sp1">备注:</span>
                                                <span class="sp2">{{ item.beizhu }}</span>
                                            </div>
                                        </div>
                                        <div class="p2">
                                            <div class="item_text">
                                                <span class="sp1">售价金额:</span>
                                                <span class="sp2">{{ item.price }}元</span>
                                            </div>
                                            <div class="item_text">
                                                <span class="sp1">游戏区服:</span>
                                                <span class="sp2">三角洲行动({{ item.qufu_text }})</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="text_2">
                                    <div class="con goods-actions" v-if="item.is_sell == 0">
                                        <span class="sp1" @click="xiajia(index, item)"
                                            v-if="item.status == 'normal'">下架</span>
                                        <span class="sp1" @click="shangjia(index, item)"
                                            v-if="item.status == 'pulloff'">上架</span>

                                        <router-link class="sp2" target="_blank"
                                            :to="{ path: '/sell', query: { id: item.id } }">
                                            编辑
                                        </router-link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>


                    <el-pagination v-if="!isMobile" class="pagebox" background @size-change="handleSizeChange"
                        @current-change="handleCurrentChange" :current-page="current_page"
                        :page-sizes="[10, 20, 30, 40, 50]" :page-size="10"
                        layout="total, sizes, prev, pager, next, jumper" :total="total">
                    </el-pagination>
                     <el-pagination v-if="isMobile" class="pagebox" background @size-change="handleSizeChange"
                        @current-change="handleCurrentChange" :current-page="current_page"
                        :page-sizes="[10, 20, 30, 40, 50]" :page-size="10"
                        layout="total, prev, pager, next" :total="total">
                    </el-pagination>

                </div>
            </div>
        </div>

		<el-dialog :visible.sync="kefuDialogVisible" title="客服信息" width="500px" center destroy-on-close>
			<div class="kefu-content">
				<div class="kefu-tip">
					<i class="el-icon-info"></i>
					<span>客服会指导您完成后续操作</span>
				</div>
				<div class="kefu-info-box">
					<div class="info-row">
						<span class="info-label">审核编号：</span>
						<span class="info-value audit-code">{{ assignedKefu.audit_code }}</span>
					</div>
					<div class="info-row">
						<span class="info-label">客服姓名：</span>
						<span class="info-value">{{ assignedKefu.name }}</span>
					</div>
					<div class="info-row">
						<span class="info-label">客服微信号：</span>
						<span class="info-value">{{ assignedKefu.wechat }}</span>
					</div>
				</div>
				<div class="kefu-qrcode" v-if="assignedKefu.qrcode">
					<div class="qrcode-label">扫码添加客服：</div>
					<div class="qrcode-box">
						<img :src="assignedKefu.qrcode" alt="客服二维码" />
					</div>
				</div>
			</div>
		</el-dialog>

	</div>

</template>


<script>
import usermenu from '@/components/dialogs/usermenu'
import {
    Notification,
    Message
} from 'element-ui'
import moment from 'moment';
export default {
    components: {
        usermenu
    },
    data() {
        return {
            status: -1,
            list: [],
            current_page: 1,
            pagesize: 10,
            total: 0,
            last_page: 0,
            list_num: 0,
            active: 0,
            kefuDialogVisible: false,
            assignedKefu: {
                audit_code: '',
                name: '',
                wechat: '',
                qrcode: ''
            },



        }
    },
    computed: {
        userinfo() {
            return this.$store.getters.userinfo
        },
        login() {
            return this.$store.getters.login
        },
        open_login() {
            return this.$store.getters.open_login
        },

        isMobile() {
            return this.$store.getters.isMobile
        },
        gamelist() {
            return this.$store.getters.gamelist
        },
        allGameList() {
            return this.$store.getters.allGameList
        },
        config() {
            return this.$store.getters.config
        },
    },
    created: function (data) {

        this.current_page = 1;
        this.pagesize = 10;
        this.addRandomData(this.current_page);


    },
    watch: {
        $route() {

        }
    },
    methods: {
        activeChange(e) {
            if (e == 0) {
                e = -1
            }
            if (e == 3) {
                e = 4
            }
            this.status = e
            this.current_page = 1;
            this.pagesize = 10;
            this.addRandomData(this.current_page);
        },
        choseOrder(status) {

            this.status = status
            this.current_page = 1;
            this.pagesize = 10;
            this.addRandomData(this.current_page);
        },


        handleSizeChange(val) {
            this.pagesize = val;
            this.addRandomData(this.current_page);
        },
        handleCurrentChange(val) {
            this.current_page = val;
            this.addRandomData(this.current_page);
        },

        open(item) {
            this.status = item
            this.current_page = 1;
            this.addRandomData(this.current_page);
        },

        //下架
        xiajia(index, item) {
            this.rq.requests.post("api/game/user/xiajia", {
                id: item.id,

            }).then(res => {

                if (res.code == 1) {
                    this.$message.success('下架成功');


                    this.list[index].status = 'pulloff'


                }

                console.log(this.list)

            }).catch(error => {

            })
        },
        //上架
        shangjia(index, item) {
            this.rq.requests.post("api/game/user/shangjia", {
                id: item.id,
            }).then(res => {

                if (res.code == 1) {
                    this.$message.success('上架成功');

                    this.list[index].status = 'normal'

                    // this.list_num++
                }

            }).catch(error => {

            })
        },
        showKefu(item) {
            if (!item.kefu_id) {
                this.$message.warning('未分配客服');
                return;
            }
            this.rq.requests.post("api/game/hall/getKefuList", {
                page: 1,
                limit: 100
            }).then(res => {
                if (res.code == 1 && res.data && res.data.data) {
                    const kefu = res.data.data.find(k => k.id === item.kefu_id);
                    if (kefu) {
                        this.assignedKefu = {
                            audit_code: item.audit_code || '',
                            name: kefu.name || '',
                            wechat: kefu.wechat || '',
                            qrcode: kefu.qrcode || ''
                        };
                        this.kefuDialogVisible = true;
                    } else {
                        this.$message.warning('客服信息不存在');
                    }
                }
            }).catch(error => {
                this.$message.error('获取客服信息失败');
            });
        },
        addRandomData(current_page) {
            this.loading = true;
            var that = this;
            this.list = []
            this.rq.requests.post("api/game/cms/arclist", {
                mygoods_status: this.status,
                channel: 30,
                page: current_page,
                pagesize: that.pagesize,
                paginate: true,
                user: 1,
                addon: "qufu,zichan,chunbi,box,duanwei,level,login_type,kefu_id,audit_code"
            }).then(res => {
                that.last_page = res.data.last_page;
                that.current_page = res.data.current_page;
                that.total = res.data.total;


                that.list = res.data.data;
                that.loading = false


            }).catch(error => {

            })
        }


    }


}
</script>

<style scoped>
.goods-actions {
	display: flex;
	align-items: center;
	gap: 8px;
	flex-wrap: nowrap;
}
.goods-actions .sp1,
.goods-actions .sp2,
.goods-actions .sp3 {
	margin-bottom: 0 !important;
}
.sp3 {
    color: #67c23a;
    cursor: pointer;
    margin-left: 10px;
}

.sp3:hover {
    text-decoration: underline;
}

.kefu-content {
    padding: 10px 0;
}

.kefu-tip {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    padding: 12px 16px;
    background: #f0f9eb;
    border-radius: 6px;
    color: #67c23a;
    font-size: 14px;
    margin-bottom: 20px;
}

.kefu-tip i {
    font-size: 18px;
}

.kefu-info-box {
    background: #f5f7fa;
    border-radius: 8px;
    padding: 16px;
    margin-bottom: 20px;
}

.kefu-info-box .info-row {
    display: flex;
    align-items: center;
    margin-bottom: 12px;
    font-size: 14px;
    flex-wrap: wrap;
}

.kefu-info-box .info-row:last-child {
    margin-bottom: 0;
}

.kefu-info-box .info-label {
    color: #909399;
    min-width: 90px;
}

.kefu-info-box .info-value {
    color: #303133;
    flex: 1;
    word-wrap: break-word;
    word-break: break-all;
    min-width: 0;
}

.kefu-info-box .info-value.audit-code {
    font-weight: bold;
    color: #409eff;
    font-size: 14px;
}

.kefu-qrcode {
    text-align: center;
}

.qrcode-label {
    font-size: 14px;
    color: #606266;
    margin-bottom: 12px;
}

.qrcode-box {
    display: inline-block;
    padding: 12px;
    background: #fff;
    border: 1px solid #ebeef5;
    border-radius: 8px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.qrcode-box img {
    width: 160px;
    height: 160px;
    object-fit: contain;
}
</style>
